import { Box, Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BORDER } from "../constants";
import { ConversationThreadTabsStyled } from "../styles";

export type ConversationThreadTab = "conversation" | "attachments";

type Props = {
  value: ConversationThreadTab;
  onChange: (value: ConversationThreadTab) => void;
  compact?: boolean;
};

const ConversationThreadTabs = ({
  value,
  onChange,
  compact = false,
}: Props) => {
  const { t } = useTranslation("messaging");
  const tabIndex = value === "attachments" ? 1 : 0;
  const height = compact ? 36 : 56;

  return (
    <Box
      sx={{
        width: "100%",
        height,
        flexShrink: 0,
        borderBottom: BORDER,
        overflow: "visible",
      }}
    >
      <ConversationThreadTabsStyled
        compact={compact}
        value={tabIndex}
        onChange={(_, next) =>
          onChange(next === 1 ? "attachments" : "conversation")
        }
      >
        <Tab
          disableRipple
          label={
            <Typography variant="header">{t("conversationTab")}</Typography>
          }
        />
        <Tab
          disableRipple
          label={
            <Typography variant="header">{t("attachmentsTab")}</Typography>
          }
        />
      </ConversationThreadTabsStyled>
    </Box>
  );
};

export default ConversationThreadTabs;
